import { render, staticRenderFns } from "./LegalAnalysisModal.vue?vue&type=template&id=7646b482&scoped=true"
import script from "./LegalAnalysisModal.vue?vue&type=script&lang=js"
export * from "./LegalAnalysisModal.vue?vue&type=script&lang=js"
import style0 from "./LegalAnalysisModal.vue?vue&type=style&index=0&id=7646b482&prod&lang=css"
import style1 from "./LegalAnalysisModal.vue?vue&type=style&index=1&id=7646b482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646b482",
  null
  
)

export default component.exports